import { ShieldX } from 'lucide-react';
import { Navigate } from 'react-router';
import { privatePaths } from '@/app/router/paths/privatePaths';
import { publicPaths } from '@/app/router/paths/publicPaths';
import { useAuthStoreHydrated } from '@/core/hooks/useAuthStoreHydrated';
import { useAuthStore } from '@/core/stores/authStore';
import { UnifiedButton } from '@/shared/components/ui/unified-button';

export default function UnauthorizedPage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const logout = useAuthStore((s) => s.logout);
  const hasHydrated = useAuthStoreHydrated();

  if (!hasHydrated) return null;
  if (!isAuthenticated) return <Navigate to={publicPaths.LOGIN} replace />;

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-6 max-w-sm text-center px-6">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-section-icon-background">
          <ShieldX size={32} className="text-negative" />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="text-xl font-semibold text-primary">Acceso no autorizado</h1>
          <p className="text-sm text-welcome-subtitle">
            No tienes permisos para ver esta página. Contacta a tu administrador si crees que esto
            es un error.
          </p>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <UnifiedButton
            buttonType="basic"
            variant="outline"
            onClick={() => (window.location.href = privatePaths.ADMIN_USERS)}
            className="w-full"
          >
            Volver al inicio
          </UnifiedButton>
          <UnifiedButton buttonType="basic" variant="default" onClick={logout} className="w-full">
            Cerrar sesión
          </UnifiedButton>
        </div>
      </div>
    </div>
  );
}
